var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Button, SelectionControlLabel, Checkbox, DropdownField, MenuItem, FormStatusMessage, } from '@one-thd/sui-atomic-components';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { b2cAccountApi } from '../../api/b2c/account';
import { validationSchema } from './validation';
import { getTextFieldStatus } from '../../utils/form';
import { getSvocId } from '../../utils/user';
import { isRecaptchaEnabled } from '../../utils/general';
import { setCloseAccountPostPageLoadAPIErrorAnalytics, setCloseAccountPostPageLoadErrorAnalytics, setCloseAccountSuccessAnalytics, } from '../../utils/close-account-page-analytics';
import { ERR_GENERIC } from '../../constants/response-error-messages';
import { CloseAccountReasonChoice } from '../../models/b2c/close-account';
import { RECAPTCHA_ACTION } from '../../constants/recaptcha';
export var AccountClosureForm = function (_a) {
    var _b, _c;
    var onCancel = _a.onCancel;
    var _d = useForm({
        resolver: yupResolver(validationSchema),
    }), control = _d.control, handleSubmit = _d.handleSubmit, formErrors = _d.formState.errors;
    var _e = useState(false), backendError = _e[0], setBackendError = _e[1];
    var currentSvocId = getSvocId();
    var executeRecaptcha = useGoogleReCaptcha().executeRecaptcha;
    var getRecaptchaToken = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = '';
                    if (!(executeRecaptcha && isRecaptchaEnabled(false))) return [3 /*break*/, 2];
                    return [4 /*yield*/, executeRecaptcha(action)];
                case 1:
                    token = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, token];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        if ((_a = formErrors.closeAccountReason) === null || _a === void 0 ? void 0 : _a.message) {
            setCloseAccountPostPageLoadErrorAnalytics(formErrors.closeAccountReason.message);
        }
    }, [(_b = formErrors.closeAccountReason) === null || _b === void 0 ? void 0 : _b.message]);
    useEffect(function () {
        var _a;
        if ((_a = formErrors.acknowledgement) === null || _a === void 0 ? void 0 : _a.message) {
            setCloseAccountPostPageLoadErrorAnalytics(formErrors.acknowledgement.message);
        }
    }, [(_c = formErrors.acknowledgement) === null || _c === void 0 ? void 0 : _c.message]);
    var closeAccountSubmit = function (_a) {
        var closeAccountReason = _a.closeAccountReason;
        return __awaiter(void 0, void 0, void 0, function () {
            var token, deactivateResponse, _b;
            var _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!currentSvocId) {
                            setBackendError(true);
                            return [2 /*return*/];
                        }
                        setBackendError(false);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, getRecaptchaToken(RECAPTCHA_ACTION.B2C_CLOSE_ACCOUNT)];
                    case 2:
                        token = _f.sent();
                        return [4 /*yield*/, b2cAccountApi.b2cDeactivateAccount({
                                closeAccountRequest: {
                                    customerAccountId: currentSvocId,
                                    inactiveReasonCode: closeAccountReason,
                                },
                            }, token)];
                    case 3:
                        deactivateResponse = _f.sent();
                        if (((_e = (_d = (_c = deactivateResponse.data.closeAccountResponse) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                            throw new Error("DEACTIVATE API RETURNED STATUS CODE ".concat(deactivateResponse.status));
                        }
                        setCloseAccountSuccessAnalytics(closeAccountReason);
                        // LOGOUT API
                        return [4 /*yield*/, b2cAccountApi.b2cLogoutAccount()];
                    case 4:
                        // LOGOUT API
                        _f.sent();
                        window.location.assign('/');
                        return [3 /*break*/, 6];
                    case 5:
                        _b = _f.sent();
                        setBackendError(true);
                        setCloseAccountPostPageLoadAPIErrorAnalytics(ERR_GENERIC.message);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return (React.createElement("form", { onSubmit: handleSubmit(closeAccountSubmit), "data-testid": "account-closure-form" },
        React.createElement(Controller, { name: "closeAccountReason", control: control, render: function (_a) {
                var _b;
                var field = _a.field;
                var value = field.value, onChange = field.onChange;
                return (React.createElement(DropdownField, { label: "Why are you closing your account?\u2009*", value: value, status: getTextFieldStatus(formErrors.closeAccountReason), fullWidth: true, id: "closeAccountReasons", onChange: onChange, statusMessage: (_b = formErrors.closeAccountReason) === null || _b === void 0 ? void 0 : _b.message, dropdownProps: {
                        placeholder: 'Select a Reason',
                        'data-testid': 'close-account-reason-select',
                    } },
                    React.createElement(MenuItem, { value: CloseAccountReasonChoice.DETAILS_REUSE, "data-testid": "DETAILS_REUSE" }, "I need to use my information in another account"),
                    React.createElement(MenuItem, { value: CloseAccountReasonChoice.NO_LONGER_REQUIRED, "data-testid": "NO_LONGER_REQUIRED" }, "I don't want a Home Depot account anymore"),
                    React.createElement(MenuItem, { value: CloseAccountReasonChoice.DUPLICATE_ACCOUNT, "data-testid": "DUPLICATE_ACCOUNT" }, "I have more than one Home Depot account"),
                    React.createElement(MenuItem, { value: CloseAccountReasonChoice.FRAUD_ACTIVITY, "data-testid": "FRAUD" }, "Fraudulent activity or security incident on my account"),
                    React.createElement(MenuItem, { value: CloseAccountReasonChoice.OTHER, "data-testid": "OTHER" }, "Other")));
            } }),
        React.createElement("div", { className: "sui-mt-8 sui-mb-8" },
            React.createElement(Controller, { name: "acknowledgement", control: control, render: function (_a) {
                    var _b;
                    var field = _a.field;
                    var onChange = field.onChange, value = field.value;
                    return (React.createElement(React.Fragment, null,
                        React.createElement(SelectionControlLabel, { label: "Please indicate that you've read the information above by checking this box.\u2009*" },
                            React.createElement(Checkbox, { "data-testid": "closeAccountCheckBox", checked: value, onChange: onChange })),
                        ((_b = formErrors.acknowledgement) === null || _b === void 0 ? void 0 : _b.message) && (React.createElement(FormStatusMessage, { id: "status-msg", status: "error" }, formErrors.acknowledgement.message))));
                } })),
        backendError && (React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Alert, { status: "error", "data-testid": "alertError" }, "Something went wrong. Refresh the page and try again."))),
        React.createElement("div", { className: "sui-flex sui-flex-wrap sm:sui-flex-nowrap sui-gap-4 sui-w sui-mt-4 sui-mb-10" },
            React.createElement(Button, { fullWidth: true, variant: "secondary", "data-testid": "cancelBtn", onClick: onCancel }, "Cancel"),
            React.createElement(Button, { fullWidth: true, variant: "primary", type: "submit", "data-testid": "closeAccountBtn" }, "Close Account"))));
};
